import { GlobalState } from '@/containers/GlobalState';
import React, { useContext } from 'react';
import {Handle, Position} from 'reactflow';


export default function OutputHandle({id, position, nodeHighlighting}) {
    const { inAColors } = useContext(GlobalState);

    const isValidOutputConnection = (connection) => {
        return !(connection.target === connection.source)
    }

    const getColor = () => {
        if (nodeHighlighting?.output) {
            if (nodeHighlighting?.error) {
                return inAColors.error[600]
            }
            if (nodeHighlighting?.info) {
                return inAColors.warning[600]
            }
        }
        return inAColors.primary[900]
    }

    return (
        <Handle
            type='source'
            position={Position.Right}
            id={id}
            style={{top: position, background: getColor(), width: 10, height: 10}}
            isValidConnection={isValidOutputConnection}
        />
    );
}
